'use client';

import classNames from 'classnames';
import { Splide, SplideSlide, SplideTrack } from '@splidejs/react-splide';
import { ServicesSubservicesSlider } from '@sapientpro/sapientpro-data-models';
import styles from './ServicesSlider.module.scss';
import AnimatedTitle from '../AnimatedTitle';
import ServiceSliderCard from './ServicesSliderCard';
import SliderArrow from '../SliderComponent/SliderArrow';

const ServiceSlider = ({ data }: { data: ServicesSubservicesSlider }) => (
  <section className={styles.serviceSlider}>
    <div className={classNames(styles.textBlock, 'container')}>
      <h2 className={styles.title}><AnimatedTitle title={data.title} /></h2>
      <p className={classNames(styles.description, 'bodyLarge')}>{data.description}</p>
    </div>
    {/* <img src='media/service-slider-decoration-dark.svg' />
    <svg style={{ overflow: 'hidden', width: '500px', height: '500px' }}>
      <use
        href='media/service-slider-decoration-dark.svg#ServiceSliderItemDecorationSVGdark'
        xlinkHref='media/service-slider-decoration-dark.svg#ServiceSliderItemDecorationSVGdark'
      />
    </svg> */}
    <Splide
      options={{
        pagination: false,
        autoWidth: true,
        gap: '24px',
        perMove: 1,
        padding: { left: '320px', right: '320px' },
        breakpoints: {
          767: {
            padding: { left: '24px', right: '24px' },
          },
          1023: {
            padding: { left: '64px', right: '120px' },
          },
          1279: {
            padding: { left: '72px', right: '120px' },
          },
          1439: {
            padding: { left: '120px', right: '120px' },
          },
          1919: {
            padding: { left: 'calc((100vw - 1040px) / 2)', right: 'calc((100vw - 1040px) / 2)' },
          },
        },
      }}
      className={styles.slider}
      hasTrack={false}
    >
      <SplideTrack className={styles.sliderTrack}>
        {data.items.map(item => (
          <SplideSlide
            key={item.id}
            className={styles.sliderSlide}
          >
            <ServiceSliderCard item={item} />
          </SplideSlide>
        ))}
      </SplideTrack>
      <div className={classNames(styles.navigation, 'splide__arrows')}>
        <SliderArrow
          type='prev'
          className={classNames(styles.arrow, styles.prev)}
        />
        <SliderArrow
          type='next'
          className={classNames(styles.arrow, styles.next)}
        />
      </div>
    </Splide>
  </section>
);

export default ServiceSlider;
